import React from 'react';
import FullLogo, { FullLogoPride } from './components/full-logo';
import HLogo from './components/h-logo';
import { jsx as ___EmotionJSX } from "@emotion/core";
const AllhomesLogo = _ref => {
  let _ref$logoType = _ref.logoType,
    logoType = _ref$logoType === void 0 ? 'full' : _ref$logoType,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$colorScheme = _ref.colorScheme,
    colorScheme = _ref$colorScheme === void 0 ? 'color' : _ref$colorScheme;
  if (logoType === 'h') {
    return ___EmotionJSX(HLogo, {
      className: className
    });
  }
  return ['pride', 'mardi-gras'].includes(colorScheme) ? ___EmotionJSX(FullLogoPride, {
    className: className
  }) : ___EmotionJSX(FullLogo, {
    colorScheme: colorScheme,
    className: className
  });
};
export default AllhomesLogo;